<template>
	<div
		id="createAttributeModal"
		style="display: block"
		class="modal"
		role="dialog"
	>
		<div class="modal-backdrop" @click="$emit('close')"></div>
		<div class="modal-dialog">
			<loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
			<div class="modal-content">
				<div class="modal-header">
					<h4 class="titleModal">Add New {{ type }}</h4>
				</div>
				<div class="modal-body">
					<div class="block inputCell vendor">
						<input
							v-model="nameAttribute"
							type="text"
							class="form-control block"
							:placeholder="type"
							v-on:keyup.enter="addNewAttribute(nameAttribute)"
						/>
					</div>
					<b-alert
						:show="dismissCountDown"
						dismissible
						variant="danger"
						@dismissed="dismissCountDown = 0"
						@dismiss-count-down="countDownChanged"
						>{{ err }}</b-alert
					>
				</div>
				<div class="modal-footer">
					<b-button class="cancelBtn" @click="$emit('close')">Cancel</b-button>
					<b-button
						class="submitBtn"
						type="submit"
						@click="addNewAttribute(nameAttribute)"
						>Done</b-button
					>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import Loading from "vue-loading-overlay";
import { getUserId } from "../utils/auth";
export default {
	name: "CreateAttribute",
	props: ["type"],
	data() {
		return {
			nameAttribute: "",
			isLoading: false,
			fullPage: false,
			err: null,
			dismissSecs: 5,
			dismissCountDown: 0
		};
	},
	components: {
		Loading
	},
	methods: {
		countDownChanged(dismissCountDown) {
			this.dismissCountDown = dismissCountDown;
		},
		addNewAttribute(attributeName) {
			if (!attributeName) {
				this.err = this.type + " name can't be blank.";
				this.dismissCountDown = this.dismissSecs;
			} else {
				this.isLoading = true;
				let userId = getUserId();
				let attributeType = this.type.replace(/\s/g, "").toLowerCase();
				let params = {
					user_id: userId,
					attribute_type:
						attributeType === "paymentmethod" ? "paymenttype" : attributeType,
					old_attribute_name: attributeName,
					new_attribute_name: attributeName
				};
				const self = this;
				this.$axios.post("attributes", params, { crossdomain: true }).then(
					response => {
						if (response.status === 200) {
							this.$store.state.attributes[this.type.toLowerCase()] =
								response.data[this.type.toLowerCase()];
							self.$emit("created", attributeName);
						}
					},
					err => {
						return err;
					}
				);
			}
		}
	}
};
</script>
